var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.isMutiple : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.program(4, data, 0),"data":data})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "         <input type=\"text\" class=\"mkts-cmpt-datepicker-start-input mkts-cmpt-datepicker-input\"> to <input type=\"text\" data-id=\"end-input\" class=\"mkts-cmpt-datepicker-end-input mkts-cmpt-datepicker-input\">\n";
},"4":function(container,depth0,helpers,partials,data) {
    return "         <input type=\"text\" class=\"mkts-cmpt-datepicker-start-input mkts-cmpt-datepicker-input\">\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div class=\"mkts-cmpt-datepicker-container\">\n"
    + ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.needInputs : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n    <div class=\"mkts-cmpt-datepicker-single\">\n        <div class=\"mkts-cmpt-datepicker-lendar\">\n            <div class=\"mkts-cmpt-datepicker-title\"></div>\n            <div class=\"mkts-cmpt-datepicker-body\"> </div>\n        </div>\n    </div>\n</div>";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/datepicker/src/html/datePicker.html
// module id = 9
// module chunks = 0